import type {
  IntervalOrigin,
  ReportDocumentOptions,
  ViewType,
} from "@digits-graphql/frontend/graphql-bearer"
import type { PreferenceValueMap } from "src/shared/config/preferenceDefinitions"
import { buildPreferenceKeys, definePreference } from "src/shared/config/preferenceDefinitions"

type PersistedStatementOptions = Record<string, ReportDocumentOptions>

export const legalEntityPreferenceDefinitions = {
  checklistOrigin: definePreference<{ origin: IntervalOrigin; timestamp: number } | undefined>()({
    key: "checklist-origin",
    kind: "json",
  }),
  inboxOrigin: definePreference<{ origin: IntervalOrigin; timestamp: number } | undefined>()({
    key: "inbox-origin",
    kind: "json",
  }),
  financialsStatementOptions: definePreference<PersistedStatementOptions | undefined>()({
    key: "financials-statement-options",
    kind: "json",
  }),
  viewType: definePreference<ViewType | undefined>()({
    key: "view-type",
    kind: "string",
  }),
} as const

export const legalEntityPreferenceKeys = buildPreferenceKeys(legalEntityPreferenceDefinitions)

export type LegalEntityPreferenceValueMap = PreferenceValueMap<
  typeof legalEntityPreferenceDefinitions
>
